module.exports = __webpack_public_path__ + "static/media/logo.08028ef0.png";